package one.healthium.onboarding.domain.configs

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import one.healthium.domain.common.TextStyle
import one.healthium.domain.user.models.PersonalPlanPeriod

@Serializable
@SerialName("personal_plan")
data class PersonalPlanScreenConfig(
    @SerialName("period") val period: PersonalPlanPeriod? = null,
    @SerialName("title") val title: String? = null,
    @SerialName("title_style") val titleStyle: TextStyle? = null,
    @SerialName("image") val image: String? = null,
    @SerialName("bottom_subtitle") val bottomSubtitle: String? = null,
    @SerialName("cta_title") val ctaTitle: String? = null,
) : ScreenConfig
